import React from 'react';
import '../styles/AppCarousel.css';

const LABELS = ['Dashboard', 'Start Workout', 'Workout', 'Complete Workout', 'Stats', 'Calendar'];

function AppCarousel({ slides }) {
  return (
    <section className="app-carousel-section">
      <div className="app-carousel-track" role="list">
        {slides.map((src, i) => (
          <div key={i} className="app-carousel-slide" role="listitem">
            <img src={src} alt={LABELS[i] || `App screen ${i + 1}`} />
          </div>
        ))}
      </div>
    </section>
  );
}

export default AppCarousel;
